import styled from "@emotion/styled";
import { keyframes } from "@emotion/react";

export const pulse = keyframes`
  0% { transform: scale(0.95); box-shadow: 0 0 0 0 rgba(91, 107, 253, 0.7); }
  70% { transform: scale(1); box-shadow: 0 0 0 10px rgba(91, 107, 253, 0); }
  100% { transform: scale(0.95); box-shadow: 0 0 0 0 rgba(91, 107, 253, 0); }
`;

const FollowUpLoader = styled.div`
  display: flex;
  align-items: center;
  padding: 10px 14px;
  border-radius: 12px;
  max-width: 80%;
  align-self: flex-start;
  background-color: ${(props) =>
    props.theme.type === "light"
      ? props.theme.gray.gray100
      : props.theme.gray.gray800};
  margin-bottom: 6px;

  .typing-dots {
    display: flex;
    gap: 4px;
  }

  .dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: #5b6bfd;
    animation: ${pulse} 1.5s infinite;
  }

  .dot:nth-of-type(1) {
    animation-delay: 0s;
  }
  .dot:nth-of-type(2) {
    animation-delay: 0.3s;
  }
  .dot:nth-of-type(3) {
    animation-delay: 0.6s;
  }
`;

// Loader component
export default function SidebarLoader() {
  return (
    <FollowUpLoader>
      <div className="typing-dots">
        <div className="dot"></div>
        <div className="dot"></div>
        <div className="dot"></div>
      </div>
    </FollowUpLoader>
  );
}
